import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../ui/Dialog/DialogActions";
import AddPlanForm from "../AddPlanForm";
import {createPlan} from "../../store/send";

const styles = theme => ({
  dialog: {
    width: "476px"
  }
});

const AddPlanModal = ({
  open,
  handleClose,
  createPlan,
  isCreatingPlan,
  createdPlan,
  classes,
  history
}) => {
  const [formData, updateFormData] = React.useState(null);

  const onConfirm = () => {
    createPlan(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  React.useEffect(() => {
    if (createdPlan && createdPlan.success) {
      updateFormData(null);
      handleClose();
    }
  }, [createdPlan]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Добавить план набора</DialogTitle>
        <DialogContent>
          <AddPlanForm
            onFormChange={updateFormData}
            disabled={isCreatingPlan}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingPlan}
            disabled={isCreatingPlan}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  isCreatingProgram: state.studyPlan.isCreatingProgram,
  createdProgram: state.studyPlan.createdProgram
});

const mapDispatchToProps = dispatch => ({
  createPlan: data => dispatch(createPlan(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(AddPlanModal)));
